// extracted by mini-css-extract-plugin
module.exports = {"content":"content-module--content--31pjo","children":"content-module--children--2cuRs","nav":"content-module--nav--1EKwu"};